import { z } from 'zod';

import { TemplateType } from '@e-origin/shared';

import { TransitConsignmentSchema } from './TransitConsignmentSchema';
import { TransitCustomsStateSchema } from './TransitCustomsStateSchema';
import {
  EnquirySchema,
  GuaranteeSchema,
  HolderOfTheTransitProcedureSchema,
  RepresentativeSchema,
  TraderAtDestinationSchema,
  TransitAuthorisationSchema,
  TransitGeneralInfoSchema,
  TransitOperationSchema,
  TransitTraceSchema,
  UnloadingRemarkSchema,
} from './TransitGeneralInfoSchema';
import { optionalBoolean, optionalDate, optionalNumber, TransitCustomsOfficeSchema } from './utils';

export const TransitSchema = z.object({
  _id: z.any().optional(),
  name: z.string().min(1, { message: 'Required' }),
  customer: z.any().optional().nullable(),
  template: z.any().optional().nullable(),
  templateType: z.nativeEnum(TemplateType).optional().nullable(),
  transactionType: optionalNumber(),
  declarant: z.any().optional().nullable(),
  deleted: optionalBoolean(),
  createdBy: z.any().optional().nullable(),
  counter: optionalNumber(),
  isArchived: optionalBoolean(),

  generalInfo: TransitGeneralInfoSchema.optional(),
  TransitOperation: TransitOperationSchema.optional(),
  Authorisation: z.array(TransitAuthorisationSchema).optional(),
  CustomsOfficeOfDeparture: TransitCustomsOfficeSchema.optional(),
  CustomsOfficeOfDestinationDeclared: TransitCustomsOfficeSchema.optional(),
  CustomsOfficeOfDestinationActual: TransitCustomsOfficeSchema.optional(),
  TraderAtDestination: TraderAtDestinationSchema.optional(),
  CustomsOfficeOfTransitDeclared: z.array(TransitCustomsOfficeSchema).optional(),
  CustomsOfficeOfExitForTransitDeclared: z.array(TransitCustomsOfficeSchema).optional(),
  HolderOfTheTransitProcedure: HolderOfTheTransitProcedureSchema.optional(),
  Representative: RepresentativeSchema.optional(),
  Guarantee: z.array(GuaranteeSchema).optional(),
  UnloadingRemark: UnloadingRemarkSchema.optional(),
  Consignment: TransitConsignmentSchema.optional(),
  customsState: TransitCustomsStateSchema.optional(),
  enquiry: EnquirySchema.optional(),
  trace: z.array(TransitTraceSchema).optional(),

  createdAt: optionalDate(),
  updatedAt: optionalDate(),
});
export type TransitData = z.infer<typeof TransitSchema>;
